export default __webpack_public_path__ + "static/media/18.026ea648.png";